import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AsymmetryVariableRangesEffects } from './effects/asymmetry-variable-ranges.effects';
import { AsymmetryVariableRangesService } from './services/asymmetry-variable-ranges.service';
import { StoreModule } from '@ngrx/store';
import * as fromAsymmetryVariableRangeses from './reducers/asymmetry-variable-ranges.reducer';
import { AsymmetryVariableRangesStoreFacade } from './facades/asymmetry-variable-ranges-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAsymmetryVariableRangeses.asymmetryVariableRangesesFeatureKey,
      fromAsymmetryVariableRangeses.reducer
    ),
    EffectsModule.forFeature([AsymmetryVariableRangesEffects]),
  ],
  providers: [AsymmetryVariableRangesService,AsymmetryVariableRangesStoreFacade],
})
export class AsymmetryVariableRangesModule {}
